import React from "react";
import Footer from "./global-components/footer";
import Navbar from "./global-components/navbar";
import PageHeader from "./global-components/page-header";
import AboutUs from "./section-components/about-us";

const About = (props) => {
  return (
    <div>
      <Navbar {...props} />
      <PageHeader headertitle="About Us" />
      <AboutUs />
      <Footer />
    </div>
  );
};

export default About;
